{
	"main": {
		"titleMotorna": "A Motore",
		"titleJadralna": "Alianti",
		"nazaj": "Indietro"
	},
	"nav": {
		"jadralna": "Calcolo Alianti",
		"motorna": "Calcolo Voli a Motore"
	},
	"labels": {
		"datumOd": "Data DA:",
		"datumDo": "Data A:",
		"klubL": "Seleziona club dell’aereo:",
		"klubP": "Seleziona club del pilota:",
		"namen": "Seleziona scopo:",
		"naloga": "Seleziona compito:",
		"pilot": "Seleziona pilota:",
		"reg": "Seleziona matricola aereo:",
		"stPristankov": "Numero di atterraggi:",
		"stLetov": "Numero di voli:",
		"casVZraku": "Tempo in aria:"
	},
	"data": {
		"title": "Dati",
		"stPristankov": "N. atterraggi:",
		"stLetov": "N. voli:",
		"casVZraku": "Durata:"
	},
	"buttons": {
		"csv": "Esporta in CSV",
		"natisni": "Stampa",
		"poslji": "Invia",
		"brisiIzbiro": "Cancella selezione",
		"brisiZapis": "Elimina record"
	},
	"table": {
		"reg": "REG",
		"vzlet": "DECOLLO",
		"pilot": "PILOTA",
		"trajanje": "DURATA",
		"naloga": "COMPITO",
		"datum": "DATA",
		"pristanek": "ATTERRAGGIO",
		"titleU": "Elenco dei voli ultraleggeri"
	},
	"modal": {
		"reg": "registrazione:",
		"vlecno": "aereo rimorchiatore:",
		"pilot": "pilota:",
		"instruktor": "istruttore:",
		"namen": "scopo:",
		"naloga": "compito:",
		"krajV": "luogo decollo:",
		"krajP": "luogo atterraggio:",
		"casV": "ora decollo:",
		"casP": "ora atterraggio:",
		"casL": "tempo di volo:",
		"stPristankov": "numero atterraggi:",
		"ifr": "ifr:",
		"nocno": "notturno:",
		"vizuelno": "visivo:",
		"opomba": "nota:",
		"datumL": "data volo:",
		"datumV": "data inserimento:"
	}
}